module.exports = __webpack_public_path__ + "media/sub6-1.b8eabd51.mp4";